const crpStates = [
  { code: '24', value: 'Acre - CRP 24ª Região' },
  { code: '15', value: 'Alagoas - CRP 15ª Região' },
  { code: '10', value: 'Amapá - CRP 10ª Região' },
  { code: '20', value: 'Amazonas - CRP 20ª Região' },
  { code: '03', value: 'Bahia - CRP 3ª Região' },
  { code: '11', value: 'Ceará - CRP 11ª Região' },
  { code: '01', value: 'Distrito Federal - CRP 1ª Região' },
  { code: '16', value: 'Espirito Santo - CRP 16ª Região' },
  { code: '09', value: 'Goiás - CRP 9ª Região' },
  { code: '22', value: 'Maranhão - CRP 22ª Região' },
  { code: '14', value: 'Mato Grosso do Sul - CRP 14ª Região' },
  { code: '18', value: 'Mato Grosso - CRP 18ª Região' },
  { code: '04', value: 'Minas Gerais - CRP 4ª Região' },
  { code: '10', value: 'Pará - CRP 10ª Região' },
  { code: '13', value: 'Paraíba - CRP 13ª Região' },
  { code: '08', value: 'Paraná - CRP 8ª Região' },
  { code: '02', value: 'Pernambuco - CRP 2ª Região' },
  { code: '21', value: 'Piauí - CRP 21ª Região' },
  { code: '05', value: 'Rio de Janeiro - CRP 5ª Região' },
  { code: '17', value: 'Rio Grande do Norte - CRP 17ª Região' },
  { code: '07', value: 'Rio Grande do Sul - CRP 7ª Região' },
  { code: '24', value: 'Rondônia - CRP 24ª Região' },
  { code: '20', value: 'Roraima - CRP 20ª Região' },
  { code: '12', value: 'Santa Catarina - CRP 12ª Região' },
  { code: '06', value: 'São Paulo - CRP 6ª Região' },
  { code: '19', value: 'Sergipe - CRP 19ª Região' },
  { code: '23', value: 'Tocantins - CRP 23ª Região' },
]

export default crpStates